/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';

import RightSideNav from '../../molecules/RightSideNav/RightSideNav';
import { RightSideViewSu } from '~components/molecules/RightSideViewSu/RightSideViewSu';
import { EStyleObj } from '../../../types';
import { TREE_MIN_WIDTH } from '~src/config';
import FileVersionsContext, {
  FileVersionsCtx,
} from '~src/contexts/FileVersionsContext';
import { useContext, useMemo, useState } from 'react';
import SidebarContext from '~src/contexts/SidebarContext';
import {
  MINIMIZED_RIGHT_BLOCK_WIDTH_CSS,
  RIGHT_BLOCK_WIDTH_CSS,
} from '~src/styles/constants';

const RightDisplaySu = () => {
  const [fileVersionsContext, setFileVersionsContext] = useState<
    FileVersionsCtx['fileVersionsContext']
  >([]);
  const fileVersionsContextChanged = useMemo(
    () => ({ fileVersionsContext, setFileVersionsContext }),
    [fileVersionsContext, setFileVersionsContext]
  );
  const { isSidebarMinimized } = useContext(SidebarContext);

  const style: EStyleObj = {
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'strech',
    width: isSidebarMinimized
      ? MINIMIZED_RIGHT_BLOCK_WIDTH_CSS
      : RIGHT_BLOCK_WIDTH_CSS,
    maxWidth: `calc(100vw - ${TREE_MIN_WIDTH}px)`,
    height: '100%',
  };

  return (
    <div css={style}>
      <FileVersionsContext.Provider value={fileVersionsContextChanged}>
        <RightSideNav />
        <RightSideViewSu />
      </FileVersionsContext.Provider>
    </div>
  );
};

export default RightDisplaySu;
